import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import { useParsedQuery } from "./useQueryString";
import removeQueryParam from "./remove-query-param";

const getQueryParam = paramName => {
	let currentParam = null;
	return query => {
		currentParam = query[paramName] || currentParam;
		return currentParam;
	};
};

function useQueryParam(paramName, { once = false } = {}) {
	const router = useRouter();
	const { asPath } = router;
	const query = useParsedQuery(asPath);

	const getParamValue = useMemo(
		() => getQueryParam(paramName), //
		[paramName],
	);
	const paramValue = getParamValue(query);

	useEffect(() => {
		if (!paramValue || !once) return;
		const newPath = removeQueryParam(asPath, paramName);
		router.replace(newPath, newPath, { shallow: true });
	}, [paramValue]);

	return paramValue;
}

export default useQueryParam;
